import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

export class DateValidator {
  /**
   * @description
   * Validator che richiede che la data non sia troppo vecchia rispetto a un anno minimo.
   * 
   * @param minYear Anno minimo accettato (es. 2015)
   * @returns Un ValidatorFn che restituisce { tooOld: { requiredYear, actualYear } } se non valido
   */
  static notTooOld(minYear: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;

      const date = new Date(value);
      if (isNaN(date.getTime())) return null; // non è una data valida

      if (date.getFullYear() < minYear) {
        return {
          tooOld: {
            requiredYear: minYear,
            actualYear: date.getFullYear()
          }
        };
      }

      return null;
    };
  }

  /**
   * @description
   * Validator che assicura che la data finale sia successiva o uguale a quella iniziale.
   * 
   * @param startKey Nome del controllo di inizio
   * @param endKey Nome del controllo di fine
   * @returns Un ValidatorFn che restituisce { dateRangeInvalid: { startDate, endDate } } se non valido
   */
  static startBeforeOrEqualEnd(startField: string, endField: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const startControl = formGroup.get(startField);
      const endControl = formGroup.get(endField);
  
      if (!startControl || !endControl) return null;
  
      const startValue = startControl.value;
      const endValue = endControl.value;
  
      if (!startValue || !endValue) return null;
  
      const start = new Date(startValue);
      const end = new Date(endValue);
  
      if (start > end) {
        const error = { dateRangeInvalid: true };
        endControl.setErrors(error);
        return error;
      }
  
      return null;
    };
  }
}